import UserDeposits from './UserWithdrawals';

export default UserDeposits;
